/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const positionLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M5 5.5h8V4H5v1.5ZM5 20h8v-1.5H5V20ZM19 9H5v6h14V9Z" />
	</SVG>
);

export default positionLeft;
